import {
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonRow,
} from "@ionic/react";
import { getFormattedValue } from "../util/UIHelper";
import { ColumnDef } from "../hooks/useQueryExec";

interface Card {
  header: string;
  columns: ColumnDef[];
  isSelectable?: boolean;
  onToggle?: (workOrderId: string) => void;
  isSelected?: boolean;
}

const CardInfo: React.FC<Card> = (props) => {
  const {
    header,
    columns,
    isSelectable = false,
    isSelected = false,
    onToggle,
  } = props;
  return (
    <>
      <IonCardHeader>
        <IonCardTitle>
          {isSelectable && (
            <IonCheckbox
              checked={isSelected}
              onClick={() => {
                onToggle?.(header);
              }}
              className="ion-margin-end"
            />
          )}
          {header}
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonGrid>
          {[...columns]
            .filter((c, i) => {
              return !c.Hidden;
            })
            .sort((a, b) => {
              return a.Order - b.Order;
            })
            .map((c, i) => {
              return (
                <IonRow key={i}>
                  <IonCol>{c.Text}</IonCol>
                  <IonCol>{getFormattedValue(c.Type, c.Value)}</IonCol>
                </IonRow>
              );
            })}
        </IonGrid>
      </IonCardContent>
    </>
  );
};

export default CardInfo;
